import { useCallback, useEffect, useState } from "react";

export function useScrollDistance() {
  const [scrollDistance, setScrollDistance] = useState(0);
  const updateScroll = useCallback(() => {
    setScrollDistance(window.scrollY);
  }, []);
  useEventListener("scroll", updateScroll);
  return scrollDistance;
}

function useEventListener(event: string, callback: () => void) {
  useEffect(() => {
    window.addEventListener(event, callback);
    return () => window.removeEventListener(event, callback);
  }, [event, callback]);
}
